import acs, { Profile } from '@mos-utils/acs';

const login = () => {
  acs.send({ type: 'LOGIN', backURL: window.location.href });
};

type ACSSubscribe = typeof acs['subscribe'];
export function getProfileWithLogin(): Promise<Profile> {
  let unsubscribe: ReturnType<ACSSubscribe>;
  return new Promise<Profile>((resolve, reject) => {
    let profileErrorHandler = (
      subscription: Parameters<typeof acs.unsubscribe>[0]
    ) => {
      acs.refetchProfile();

      profileErrorHandler = () => {
        acs.unsubscribe(subscription);
        reject();
      };
    };
    let exiting = false;
    const subscription: Parameters<ACSSubscribe>[0] = function (message) {
      if (exiting) {
        return;
      }
      if (Array.isArray(message)) {
        const messageTypes = new Set(message.map(({ type }) => type));
        if (messageTypes.has('EXITING')) {
          exiting = true;
        } else if (messageTypes.has('USER_UNAUTHORIZED')) {
          login();
        }
      } else if (message.type === 'USER_UNAUTHORIZED') {
        login();
      } else if (message.type === 'EXITING') {
        exiting = true;
      } else if (message.type === 'PROFILE_ERROR') {
        profileErrorHandler(subscription);
      } else if (message.type === 'PROFILE_UPDATED') {
        resolve(message.profile);
      }
    };
    unsubscribe = acs.subscribe(subscription);
    acs.refetchProfile();
  })
    .then((profile) => {
      unsubscribe?.();
      return profile;
    })
    .catch(() => {
      unsubscribe?.();
      return Promise.reject();
    });
}
